var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("작품가치 제고")])]), _c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-20 mb-md-40"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("작품 부가가치 서비스")])]), _c('div', {
    staticClass: "my-n14 my-md-n20"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-valuations-img.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v(" 상태 검사 서비스 "), _c('v-divider', {
    staticClass: "grey-da h-10px mx-6 my-auto mx-md-10",
    attrs: {
      "vertical": ""
    }
  }), _c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("Condition Reporting")])], 1)]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("경매출품 예정인 작품에 한하여, 처분할 소장품에 대한 상태검사를 실시합니다.")]), _c('ul', {
    staticClass: "letter-list mt-4 mt-md-6"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("출품작품이 50점 미만일 경우에는 무료로 진행되며, <약식 상태보고서>를 작성해 드립니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("대출, 납세, 재산분할 등의 목적으로 정밀한 상태검사를 원하는 경우에는 유료로 진행되며, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("기관 제출용 <정식 상태보고서>를 작성해 드립니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-valuations-img2.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v(" 목록 작성 서비스 "), _c('v-divider', {
    staticClass: "grey-da h-10px mx-6 my-auto mx-md-10",
    attrs: {
      "vertical": ""
    }
  }), _c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("Cataloging")])], 1)]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("경매출품 예정인 작품에 한하여, 다음과 같은 항목으로 학술조사를 실시합니다.")]), _c('ul', {
    staticClass: "letter-list mt-4 mt-md-6"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("작가 확인, 작품명 확인, 크기 실측, 연도 체크, 작가 싸인 체크, 고리형태, 에디션 여부 등")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("소장품에 대한 현장 실사를 바탕으로, 경매출품 목적의 <소장품 목록>을 작성해 드립니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-valuations-img3.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v("소장품 특별전 개최")])]), _c('div', [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("방대한 혹은 독특한 컬렉션을 형성한 소장가의 소장품을 중심으로 특별전시를 개최할 수 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("있습니다.")]), _c('p', [_vm._v("소장가는 당사에게 기획한 특별전시를 통하여 프라이빗(비공개) 판매를 하실 수 있습니다.")])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-valuations-img4.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v(" 소장품 원고작성 서비스 "), _c('v-divider', {
    staticClass: "grey-da h-10px mx-6 my-auto mx-md-10",
    attrs: {
      "vertical": ""
    }
  }), _c('span', {
    staticClass: "font-weight-regular"
  }, [_vm._v("Description")])], 1)]), _c('div', [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("경매출품 예정인 작품에 한하여, 개별작품에 대한 설명문 원고를 무료로 작성할 수 있습니다.")]), _c('p', [_vm._v("경매에 출품되지 않는 작품이나, 기관에서의 <소장품 카드> 작성을 위한 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("<작품원고 작성>은 유료입니다.")])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    staticClass: "h-100 py-4 py-md-6"
  }, [_c('div', {
    staticClass: "gallery-card d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "gallery-card__img-wrap"
  }, [_c('v-img', {
    staticClass: "grey-ef",
    attrs: {
      "aspect-ratio": 585 / 240,
      "src": "/images/sub/service/service-valuations-img5.png"
    }
  })], 1), _c('div', {
    staticClass: "gallery-card__con h-100 py-20 pt-lg-20 pb-lg-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs d-flex flex-wrap align-center"
  }, [_vm._v("가치 등급 부여")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("경매출품 예정인 작품에 한하여, 개별작품에 대한 가치등급을 조사할 수 있습니다. ")]), _c('ul', {
    staticClass: "letter-list mt-4 mt-md-6"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("미술사학 및 미술시장 측면에서 소장품의 가치등급을 산정해 드립니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("가치등급은 캐터옥션의 <가치등급 기준표>를 적용하여 부여합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("가치 등급 부여를 통하여, 지속 관리할 작품과 처분할 작품을 구분할 수 있으며, 좀 더 새로운 시각에서 작품을 조명할 수 있을 것입니다. ")])])]), _c('ul', {
    staticClass: "letter-list mt-4 mt-md-6"
  }, [_c('li', [_c('em', [_vm._v("※")]), _c('span', [_vm._v("당사는, 대출, 납세, 재산분할, 보험가입, 기부 등의 특수 목적을 위한 가격 감정은 수행하지 않습니다."), _c('br'), _vm._v(" 한국화랑협회 등의 미술품 감정 전문기관에 의뢰하여 진행하시길 권해 드립니다.")])])])])]), _c('v-divider', {
    staticClass: "primary"
  })], 1)])])], 1)], 1)])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }